import { render, staticRenderFns } from "./WizardRow.vue?vue&type=template&id=4048e731&scoped=true&"
import script from "./WizardRow.vue?vue&type=script&lang=js&"
export * from "./WizardRow.vue?vue&type=script&lang=js&"
import style0 from "./WizardRow.vue?vue&type=style&index=0&id=4048e731&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048e731",
  null
  
)

export default component.exports